import { ErrorBoundary } from '@betterment/shared-components';

import { ContentCardView } from './components/ContentCardView';

export const SecondaryContentCard: React.FC = () => {
  return (
    <ErrorBoundary fallbackType="none">
      <ContentCardView location="accountOverviewSecondaryCard" />
    </ErrorBoundary>
  );
};
